export default "__VITE_ASSET__DfeM_ntz__"